import {
  useCompositeGroupLabel
} from "../__chunks/6FRHNZA6.js";
import "../__chunks/CTVLGQZG.js";
import "../__chunks/F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import "../__chunks/PNRLI7OV.js";

// src/combobox/combobox-group-label.ts
var useComboboxGroupLabel = createHook(
  (props) => {
    props = useCompositeGroupLabel(props);
    return props;
  }
);
var ComboboxGroupLabel = createComponent(
  (props) => {
    const htmlProps = useComboboxGroupLabel(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  ComboboxGroupLabel.displayName = "ComboboxGroupLabel";
}
export {
  ComboboxGroupLabel,
  useComboboxGroupLabel
};
